export const hasDatePassed = (date: Date) => date < new Date();

export function isParsableDate(
  value: unknown,
): value is string | number | Date {
  const isAllowed =
    (typeof value === 'string' && value.trim() !== '') ||
    (typeof value === 'number' && value !== 0) ||
    value instanceof Date;

  if (!isAllowed) return false;

  const date = value instanceof Date ? value : new Date(value);
  const isParsableDate = !Number.isNaN(date.getTime());

  return isParsableDate;
}
